import React, { useState, useEffect } from "react"
import { Field, ErrorMessage, getIn } from "formik"
import ErrorPopUp from '../Shared/ErrorPopUp'
import FormikCheckbox from '../Shared/FormikCheckbox'
import GenderSelect from '../Shared/GenderSelect'
import UserTypeSelect from '../Shared/UserTypeSelect'
import PasswordHelper from "../Shared/PasswordHelper"
import owasp from "owasp-password-strength-test"

owasp.config({
  allowPassphrases: false,
  minLength: 4,
});


export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-8 col-lg-offset-2 col-md-10 col-md-offset-1 col-sm-12 col-xs-12">

      <div className="row">
        <div className="form-inline">

          <div className="col-lg-3 col-sm-12">
            <label></label>
            <Field
              component={FormikCheckbox}
              name="status"
              id="status"
              label={"کاربر فعال است"}
            />
          </div>
          <div className="clearfix form-row"></div>

          <div className={"col-lg-4 col-sm-12 " + (touched.userType && errors.userType && "has-error")}>
            <label>نوع کاربر</label>
            <UserTypeSelect name="userType" value={values.userType} defaultValue={values.userType}
              onChange={(val) => {
                setFieldValue('userType', val);
              }}

            />
            <ErrorPopUp error={errors.userType} touched={touched.userType} type="select" />
          </div>

          <div className="col-lg-4 col-sm-12">
            <label>تلفن همراه</label>
            <Field type="text"

              name="mobile"
              className={getIn(touched, "mobile") ? getIn(errors, "mobile") ? "text-input has-error" : "text-input" : "text-input has-error"}
            />
            <ErrorPopUp error={errors.mobile} touched={touched.mobile} type="fullText" />
          </div>

          <div className="col-lg-4 col-sm-12">
            <label>ایمیل</label>
            <Field type="text"

              name="email"
              className={getIn(touched, "email") ? getIn(errors, "email") ? "text-input has-error" : "text-input" : "text-input has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="email" />
          </div>

          <div className="clearfix form-row"></div>
          
          <div className="col-lg-4 col-sm-12">
            <label>جنسیت</label>
            <GenderSelect name="gender" value={values.gender} defaultValue={values.gender}
              onChange={(val) => {
                setFieldValue('gender', val);
              }}

            />
            <ErrorPopUp error={errors.gender} touched={touched.gender} type="select" />
          </div>

          <div className="col-lg-4 col-sm-12">
            <label>نام</label>
            <Field type="text"

              name="firstName"
              className={getIn(touched, "firstName") ? getIn(errors, "firstName") ? "text-input has-error" : "text-input" : "text-input has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="firstName" />
          </div>

          <div className="col-lg-4 col-sm-12">
            <label>نام خانوادگی</label>
            <Field type="text"

              name="lastName"
              className={getIn(touched, "lastName") ? getIn(errors, "lastName") ? "text-input has-error" : "text-input" : "text-input has-error"}
            />
            <ErrorMessage component={ErrorPopUp} name="lastName" />
          </div>

          <div className="clearfix form-row"></div>

            <PasswordInput setFieldValue={setFieldValue} touched={touched} errors={errors}
              onChange={val => setFieldValue("password", val)}
              password={values.password}
              changePass={values.changePass}
              id={values.id}
            />

        </div>
      </div>

    </div>

  </div>
);


export const PasswordInput = (props) => {

  const [errors, setErrors] = useState(props.errors)
  const [passwordValue, setPasswordValue] = useState(props.password)
  const [passwordTestStatus, setPasswordTestStatus] = useState({
    minLengthTestPasses: false,
    // maxLengthTestPasses: true,
    // repeatedCharactersTestPasses: true,
    // containsUppercaseLetterTestPasses: false,
    // containsLowercaseLetterTestPasses: false,
    // containsNumberTestPasses: false,
    // containsSpecialCharacterTestPasses: false
  })

  useEffect(() => {

    setErrors(props.errors)

  }, [props.errors])



  const passwordHelperCriteria = [
    { value: passwordTestStatus.minLengthTestPasses, description: "طول کلمه عبور حداقل باید 4 کاراکتر باشد" },
    // { value: maxLengthTestPasses, description: "128 characters maximum" },
    // {
    //   value: repeatedCharactersTestPasses,
    //   description: "No more than 3 repeated characters in a row"
    // },
    // {
    //   value: passwordTestStatus.containsLowercaseLetterTestPasses,
    //   description: "کلمه عبور باید حداقل شامل یک حرف کوچک باشد"
    // },
    // {
    //   value: passwordTestStatus.containsUppercaseLetterTestPasses,
    //   description: "کلمه عبور باید حداقل شامل یک حرف بزرگ باشد"
    // },
    // {
    //   value: passwordTestStatus.containsNumberTestPasses,
    //   description: "کلمه عبور باید حداقل شامل یک کاراکتر عددی باشد"
    // },
    // {
    //   value: passwordTestStatus.containsSpecialCharacterTestPasses,
    //   description: "کلمه عبور باید حداقل شامل یک کاراکتر خاص باشد"
    // }
  ];


  const onPasswordChange = (e) => {
    const { failedTests: failed, passedTests: passed } = owasp.test(
      e.target.value
    );
    const testDefinitelyPassed = testIndex => {
      // // console.log(!failed.includes(testIndex) && passed.includes(testIndex));
      return !failed.includes(testIndex) && passed.includes(testIndex);
    };

    // const { setFieldTouched, setFieldValue } = this.props;
    props.onChange(e.target.value);
    setPasswordValue(e.target.value)
    // setFieldTouched("password");

    let passwordTestStatus = {
      minLengthTestPasses: testDefinitelyPassed(0),
      // maxLengthTestPasses: testDefinitelyPassed(1),
      // repeatedCharactersTestPasses: testDefinitelyPassed(2),
      // containsLowercaseLetterTestPasses: testDefinitelyPassed(3),
      // containsUppercaseLetterTestPasses: testDefinitelyPassed(4),
      // containsNumberTestPasses: testDefinitelyPassed(1),
      // containsSpecialCharacterTestPasses: testDefinitelyPassed(6)
    }

    setPasswordTestStatus(passwordTestStatus)

  }

  return (
    <React.Fragment>

      <br />
      <hr />
      {props.id &&
        <div className="col-lg-6 col-sm-12">
          <Field
            component={FormikCheckbox}
            name="changePass"
            id="changePass"
            label={"کلمه عبور"}
          />
        </div>
      }
      <div className="clearfix form-row"></div>

      <div className="col-lg-6 col-sm-12">
        <label>کلمه عبور</label>
        <Field type="password"
          disabled={props.id && !props.changePass}
          autoComplete="off"
          id="password"
          name="password"
          value={passwordValue}
          onChange={e => onPasswordChange(e)}
          className={
            getIn(props.errors, "password") &&
              getIn(props.touched, "password")
              ? "text-input has-error"
              : "text-input required"
          }
        />
        <ErrorPopUp error={props.errors.password} touched={props.touched.password} type="fullText" />
      </div>

      <div className="col-lg-6 col-sm-12">
        <label>تکرار کلمه عبور</label>
        <Field type="password"
          disabled={props.id && !props.changePass}
          name="confirmPassword"
          className={
            getIn(props.errors, "confirmPassword") &&
              getIn(props.touched, "confirmPassword")
              ? "text-input has-error"
              : "text-input required"
          }
        />
        <ErrorPopUp error={props.errors.confirmPassword} touched={props.touched.confirmPassword} type="fullText" />
      </div>
      <div className="clearfix form-row"></div>
      <div className="col-lg-12 col-sm-12">
        <label></label>
        <PasswordHelper criteria={passwordHelperCriteria} />
      </div>

    </React.Fragment>
  )
}